/**
 * Analytics export API — CSV downloads from /api/analytics-export.
 *
 * Extracted from the Customers page so both the page button and the ⌘K
 * command palette trigger the same authenticated download. Uses a raw
 * fetch (not apiRequest) because the response is a blob, not JSON.
 */
import { API_BASE_URL, getAuthToken, getWorkspaceId } from './core.js';

/**
 * Download the full customer list as CSV and hand it to the browser as a
 * file download. Throws on a non-OK response so callers can toast.
 */
export async function downloadCustomersCsv(): Promise<void> {
  const headers: Record<string, string> = {};
  const token = getAuthToken();
  const workspaceId = getWorkspaceId();
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (workspaceId) headers['X-Workspace-Id'] = workspaceId;

  // Explicit start date: the endpoint defaults to the last 30 days, but
  // "Export" on the CDP must mean the full customer list.
  const response = await fetch(
    `${API_BASE_URL}/analytics-export/csv?type=customers&start=2020-01-01`,
    { headers },
  );
  if (!response.ok) throw new Error(`Export failed (${response.status})`);

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `customers-${new Date().toISOString().split('T')[0]}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
